import { useState } from 'react'
import { useCustomers } from '../../hooks/useCustomers'
import { Table } from '../Common/Table'
import { Pagination } from '../Common/Pagination'
import { Button } from '../Common/Button'

export function CustomersList() {
  const [page, setPage] = useState(1)
  const { customers, total, loading } = useCustomers(page)

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'status', label: 'Status' },
  ]

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-sfp-darkgray">Customers</h1>
        <Button variant="primary">Add Customer</Button>
      </div>
      <Table columns={columns} data={customers} loading={loading} />
      <Pagination
        currentPage={page}
        totalItems={total}
        pageSize={100}
        onPageChange={setPage}
      />
    </div>
  )
}
